import axios from "axios";
import { API_URL } from "../constants/api";
import { useQuery } from "react-query";

const APIURL = axios.create({
  baseURL: API_URL,
});
const getLang = () => {
  return localStorage.getItem("lang");
};
const getRoomNumber = () => {
  return localStorage.getItem("validated_room_number");
};
const Checkout = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/orders/checkout`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: getLang(),
      "Room-Number-From-Dine-in": getRoomNumber(),
    },
  });
};
export const ShowCheckout = (uuid, lang) => {
  return useQuery(`checkout`, () => Checkout(uuid, lang));
};

// Lightweight helper for applying a tip via mutation (use inside components)
export const applyTipRequest = async (uuid, tip, tipper = "guest") => {
  const response = await APIURL.post(
    `/${uuid}/orders/add-tips`,
    { tips: tip, tip_person: tipper },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: getLang(),
        "Room-Number-From-Dine-in": getRoomNumber(),
      },
    },
  );
  return response.data;
};

// Apply a tip on an open check via the dedicated open-check endpoint (multipart form-data)
export const applyOpenCheckTipRequest = async (
  uuid,
  tip,
  tipper = "guest",
  restaurantId,
) => {
  const formData = new FormData();
  formData.append("tips", tip);
  formData.append("tip_person", tipper);
  if (restaurantId) {
    formData.append("restaurant_id", restaurantId);
  }
  const response = await APIURL.post(
    `/${uuid}/orders/add-open-check-tips`,
    formData,
    {
      headers: {
        Accept: "application/json",
        lang: getLang(),
        "Room-Number-From-Dine-in": getRoomNumber(),
      },
    },
  );
  return response.data;
};

const openCheckout = async (uuid, lang, restaurant_uuid) => {
  return await APIURL.get(
    `/${uuid}/orders/get-open-check${
      restaurant_uuid ? `/${restaurant_uuid}` : ""
    }`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: getLang(),
        "Room-Number-From-Dine-in": getRoomNumber(),
      },
    },
  );
};

export const ShowOpenCheckout = (uuid, lang, restaurant_uuid) => {
  return useQuery([`open-checkout`, restaurant_uuid], () =>
    openCheckout(uuid, lang, restaurant_uuid),
  );
};
